
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'

export default {
  inject: ['info'],
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    pick: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: this.pick
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    const that = this
    bus.$on('changeTextTraderMenu2', (text) => {
      that.active = text
    })
    console.log('文字版交易商菜单')
  },
  methods: {
    changeMenu(text) {
      this.active = text
      const clickMenu = {
        val: text,
        time: dayjs().format('x')
      }
      bus.$emit('changeTextTraderMenu', clickMenu)
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
